<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('samples.range_add_info') }}</p>
    <hr />
    <br />
    <template>
      <div class="custom-table-responsive table-responsive">
        <table
          class="table table-striped table-bordered table table-journals not-last-td"
        >
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('samples.range_name') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_lower_operator') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_lower') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_upper_operator') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.limit_upper') }} *
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.recommendation_kg_ha') }} *
              </th>
              <th scope="col" class="text-center p-0 custom-header-label">
                {{ $t('common_words.actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index_num in range_len" :key="index_num">
              <td class="text-center" style="min-width: 250px">
                <fg-input
                  style="width: 80%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-names"
                  type="text"
                  v-model="model.names[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center vertical-custom" style="min-width: 200px">
                <el-select
                  style="width: 40%; margin: auto"
                  clearable
                  class="select-primary custom-width-select shadow-sm ops-rels required-second-step required-lim_inf_operators"
                  size="large"
                  v-model="model.lim_inf_operators[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="disableSup(index_num - 1)"
                  filterable
                >
                  <el-option value=">" label=">"></el-option>
                  <el-option value=">=" label=">="></el-option>
                  <el-option value="=" label="="></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-infs"
                  type="number"
                  v-model.number="model.lim_infs[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center vertical-custom" style="min-width: 200px">
                <el-select
                  style="width: 40%; margin: auto"
                  clearable
                  class="select-primary custom-width-select shadow-sm required-opsups"
                  size="large"
                  v-model="model.lim_sup_operators[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  :disabled="disabled_sups[index_num - 1]"
                  filterable
                >
                  <el-option value="<" label="<"></el-option>
                  <el-option value="<=" label="<="></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  type="number"
                  class="required-sups"
                  v-model.number="model.lim_sups[index_num - 1]"
                  :disabled="disabled_sups[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center" style="min-width: 200px">
                <fg-input
                  style="width: 50%; margin-right: auto; margin-left: auto"
                  class="required-second-step required-recommendations"
                  type="number"
                  v-model.number="model.recommendations[index_num - 1]"
                >
                </fg-input>
              </td>
              <td class="text-center vertical-custom" style="min-width: 100px">
                <div class="d-flex justify-content-center mt-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="addRow"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="range_len > 1"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="handleDelete(index_num - 1)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-show="errorAlert">
        <div class="col-lg-12">
          <br />
          <el-alert
            ref="error_alert"
            :title="$t('common_words.errors')"
            type="error"
            >{{ error }}</el-alert
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        names: [],
        lim_inf_operators: [],
        lim_infs: [],
        lim_sup_operators: [],
        lim_sups: [],
        recommendations: [],
      },
      disabled_sups: [false],
      range_len: 1,
    };
  },

  mixins: [mixinMasters, MixinPermissions],

  methods: {
    addRow() {
      this.disabled_sups.push(false);
      this.range_len++;
    },

    validate() {
      let passed = true;
      this.model.names.forEach((_, index) => {
        if (this.model.lim_inf_operators[index] == null) {
          this.validationInput('lim_inf_operators', index);
          passed = false;
        } else if (this.model.lim_infs[index] == null) {
          this.validationInput('infs', index);
          passed = false;
        } else if (
          this.model.lim_sups[index] &&
          parseFloat(this.model.lim_infs[index]) >=
            parseFloat(this.model.lim_sups[index])
        ) {
          this.validationInput('infs', index);
          this.showError(
            'op-rels',
            'custom-has-error',
            i18n.t('show_notification.ground.limits_warning')
          );

          passed = false;
        } else if (
          this.model.lim_sups[index] &&
          this.model.lim_sup_operators[index] == null
        ) {
          this.validationInput('opsups', index);
          this.showError(
            'op-relss',
            'custom-has-error',
            i18n.t('show_notification.ground.lower_operator_notice')
          );

          passed = false;
        } else if (
          index > 0 &&
          parseFloat(this.model.lim_infs[index - 1]) >=
            parseFloat(this.model.lim_infs[index])
        ) {
          this.validationInput('infs', index);
          this.showError(
            'op-relss',
            'custom-has-error',
            i18n.t('show_notification.ground.ranges_warning')
          );

          passed = false;
        } else if (
          index > 0 &&
          parseFloat(this.model.lim_sups[index - 1]) != 0 &&
          this.model.lim_sup_operators[index - 1] != null &&
          ((this.model.lim_sup_operators[index - 1] == '<' &&
            parseFloat(this.model.lim_infs[index]) <=
              parseFloat(this.model.lim_sups[index - 1])) ||
            (this.model.lim_sup_operators[index - 1] == '<=' &&
              parseFloat(this.model.lim_infs[index]) <
                parseFloat(this.model.lim_sups[index - 1])))
        ) {
          let msg = '';

          if (this.model.lim_sup_operators[index - 1] == '<') {
            msg = i18n.t('message.ground.new_range_size_notice');
          } else if (this.model.lim_sup_operators[index - 1] == '<=') {
            msg = i18n.t('message.ground.new_range_size_warning');
          }

          this.validationInput('infs', index);
          this.showError('op-relss', 'custom-has-error', msg);

          passed = false;
        }
      });

      if (passed) {
        return this.$validator
          .validateAll()
          .then((res) => {
            this.$emit('on-validated', res, this.model);
            this.$emit('fillrangeGroundForm', 'secondStep');
          })
          .then((resp) => {
            return this.validationInputsRequired('second-step');
          });
      }
    },

    disableSup(index) {
      if (this.model.lim_inf_operators[index] == '=') {
        this.disabled_sups[index] = true;
        this.model.lim_sup_operators[index] = null;
        this.model.lim_sups[index] = null;
      } else {
        this.disabled_sups[index] = false;
      }
    },

    handleDelete(indexnum) {
      try {
        this.model.names.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_inf_operators.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_infs.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_sup_operators.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.lim_sups.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.recommendations.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.details_ids.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.disabled_sups.splice(indexnum, 1);
      } catch (error) {}

      this.range_len--;
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        let editForm = JSON.parse(sessionStorage.getItem('editForm'));

        this.model.names = Object.assign([], editForm.names);
        this.model.lim_inf_operators = Object.assign(
          [],
          editForm.lim_inf_operators
        );
        this.model.lim_infs = Object.assign([], editForm.lim_infs);
        this.model.lim_sup_operators = Object.assign(
          [],
          editForm.lim_sup_operators
        );
        this.model.lim_sups = Object.assign([], editForm.lim_sups);
        this.model.recommendations = Object.assign(
          [],
          editForm.recommendations
        );
        this.model.details_ids = Object.assign([], editForm.details_ids);
        this.model.details_ids_bck = Object.assign(
          [],
          editForm.details_ids_bck
        );
        this.model.id = editForm.id;
        this.range_len = editForm.range_details.length;

        this.showHideLoading();
      } else {
        this.showHideLoading();
      }
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style></style>
